import type { ApiClient } from '@hetivo/hetivo-lib-front-utils';
import type { HetivoApiResponse, TenantProfile } from '@hetivo/hetivo-lib-types';

export interface TenantProfileApi {
  getTenantProfile: () => Promise<TenantProfile>;
}

export function createTenantProfileApi(client: ApiClient): TenantProfileApi {
  return {
    getTenantProfile: async (): Promise<TenantProfile> => {
      const response = await client.execute<HetivoApiResponse<TenantProfile>>(() => client.instance.get('/tenants/me'));
      if (!response.data) throw new Error('getTenantProfile: unexpected empty response');
      return response.data;
    },
  };
}
